import React, { Component } from "react";
import { Tooltip, message, Icon, Tabs } from "antd";
import ExportUtil from '../../../common/ExportUtil'
import API_URL from "../../../common/url";
import { queryApprovalUserCached } from '../../../common/permissionCache';
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';
import AssignUser from "./AssignUser";
import fp from "../../../utils/fp";
import cf from "../../../utils/cf";
import moment from "moment";
import SchemeInfor from "./SchemeInfor";
import Update from "./Update";
import "./index.less";
import VersionRecord from "./VersionRecord";
import OperationLog from "./OperationLog";
import OperateReason from "./OperateReason";
import { saveParams } from '../../../actions/noticeActions';
import { saveEvaluateParams } from '../../../actions/clinicalEvaluationActions';
import { connect } from "react-redux";
import UpdateLog from "./UpdateLog";
import TotalPriceModal from "./TotalPriceModal";
import SecEvaluation from "./SecEvaluation";
import QuoteVersionRecord from "./QuoteVersionRecord";
import FinalQuotation from "./FinalQuotation";
import ReturnModal from "./ReturnModal";
import FloorPrice from "./FloorPrice";
import TotalPiceRequestRecord from "../../businessOffer/businessOfferRecord/TotalPiceRequestRecord";
import UserDetail from "../../investigation/UserDetail";
import FloorPriceModal from "./FloorPriceModal";
import AssociatedEvaluationRecord from "./AssociatedEvaluationRecord";
import ConfigColumn from "./ConfigColumn";
import RegisterBidding from "./RegisterBidding";
import Fetch from "../../../common/Fetch";
import renderEnhancer from "../../shared/renderEnhancer";
import cellRenderEnhancer from "../../shared/cellRenderEnhancer";
import format from "../../shared/format";
import RegisterGp from "./RegisterGp";
import GPCalculateModal from './GPCalculateModal';
import ModifyReferencePriceModal from './ModifyReferencePriceModal';
import EvaluateSite from "./EvaluateSite";

const TabPane = Tabs.TabPane;
const tabs = [
    {tab: '临床评估', key: 'current'},
    {tab: '历史记录', key: 'history'},
    {tab: 'GP', key: 'GP'},
]

class ClinicalEvaluationRecord extends Component {
    state = {
        data: [],
        tableHeader: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        historyStatus: 'current',
        canAuditAmountUser: false,  //可查看列表金额的特殊配置人员
        gpOpreateFlag: false, //gp操作权限
        gpViewFlag: false, //gp查看权限
        isSeniorUserBo: false, 
        isLineDeptBO: false, 
        isGpFinSet: false, 
        isLineCharge: false,
    }

    componentDidMount() {
        const urlParams = this.getUrlParams(); //urlParams为url地址问号后面的数据
        const { params, evaluateParams } = this.props; //params为消息通知传来的数据；evaluateSearchParams为页面返回时，原先保留的数据
        const { evaluateSearchParams, evaluatePagination, feedBack } = evaluateParams;
        this.setState({
            searchParams: feedBack ? { ...evaluateSearchParams, ...urlParams } : { ...params, ...urlParams }, 
            pagination: feedBack ? { ...evaluatePagination } : this.state.pagination,
        },()=>{
            if (feedBack) {
                this.props.saveEvaluateParams({
                    evaluatePagination: {},
                    evaluateSearchParams: {},
                    feedBack: false,
                });
            };
            // this.loadData();
            this.getHeader();
        })
        this.queryEvaluateRecordPremissions();
        this.queryGpAuth();
        this.queryApprovalUser();
    }

    componentWillUnmount() {
        this.props.saveParams({ 
            evaluateCode: undefined,
        });
    }
    queryApprovalUser = () => {
        queryApprovalUserCached(undefined, res => {
            const { isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge } = res;
            this.setState({ isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge });
        });
    }

    //查询临床评估记录权限
    queryGpAuth = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.gpAuth,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { gpOpreateFlag, gpViewFlag } = res;
                this.setState({ gpOpreateFlag, gpViewFlag });
            }
        };
        $.sendRequest(options);
    }

    getUrlParams = () => {
        let href = window.location.href;
        let obj = {};
        if (href.includes("?")) {
            let query = href.substring(href.indexOf("?") + 1);
            let item = query.split("&");
            for (let i = 0; i < item.length; i++) {
                let arr = item[i].split("=");
                obj[arr[0]] = arr[1];
            }
        };
        return obj
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    queryEvaluateRecordPremissions = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecordPremissions,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { evaluatePremissions = [] } = res;
                const { userId } = sessionStorage;
                const canAuditAmountUser = evaluatePremissions.some(el => el == userId);
                this.setState({ canAuditAmountUser });
            }
        };
        $.sendRequest(options);
    };

    loadData = () => {
        const { searchParams, pagination, historyStatus } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const curParams = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecords,
            data: {
                offset: current,
                limit: pageSize,
                ...curParams,
                researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
                historyStatus,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                datas.map(el => {
                    //项目服务内容取值处理
                    el.evaluateRecordServeText = el.evaluateRecordServes.map(el => el.evaluateServeName).join(';');
                });
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };
    loadGPData = () => {
        const { searchParams, pagination } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const curParams = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryQuotationGpDataList,
            data: {
                offset: current,
                limit: pageSize,
                ...curParams,
                researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    getHeader = () => {
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'EVALUATE_RECORD_CODE'
        }).then(res => {
            this.setState({ tableHeader: res.EVALUATE_RECORD_CODE }, () => {
                this.loadData();
            });
        })
    }

    search = () => {
        const { pagination = {}, historyStatus } = this.state;
        pagination.current = 1;
        this.setState({ pagination },
            () => {
                if (historyStatus === 'GP') {
                    this.loadGPData();
                } else {
                    this.loadData();
                }
            }
        );
    };

    showSchemeInfor = (record) => {
        this.SchemeInforRef.show(record);
    }

    // 打开GP测算弹窗
    goGpCalculate = (evaluateRecordId, basePriceStatus) => {
        this.GPCalculateModalRef.show(evaluateRecordId, basePriceStatus, null, 'GPtable');
    }

    // 打开修改参考FTE单价弹窗
    goModifyReferencePrice = (record) => {
     this.ModifyReferencePriceModalRef.show(record);
    }
    
    getColumns = () => {
        // const columns = [
        //     {
        //         title: '时间',
        //         dataIndex: 'yearMonthNum',
        //         key: 'yearMonthNum',
        //         width: 100,
        //         fixed: 'left',
        //     }, {
        //         title: '临床评估单号',
        //         dataIndex: 'evaluateCode',
        //         key: 'evaluateCode',
        //         width: 100,
        //         fixed: 'left',
        //     }, {
        //         title: '业务机会编号',
        //         dataIndex: 'businessOpportunityNum',
        //         key: 'businessOpportunityNum',
        //         width: 100,
        //         fixed: 'left',
        //     }, {
        //         title: '方案编号',
        //         dataIndex: 'evaluateSerialNumber',
        //         key: 'evaluateSerialNumber',
        //         width: 100,
        //         fixed: 'left',
        //         render: (text, record) => <a onClick={() => this.showSchemeInfor(record)}>{text}</a>
        //     }, {
        //         title: '报价状态',
        //         dataIndex: 'evaluateStatusShow',
        //         key: 'evaluateStatusShow',
        //         width: 160,
        //         fixed: 'left',
        //         render: (text, record) => {
        //             const { feedbackMessage } = record;
        //             return feedbackMessage ? <span> 
        //                 {text}
        //                 <Tooltip overlayStyle={{ width: 140 }} placement="top" title={feedbackMessage}>
        //                     <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
        //                 </Tooltip>
        //             </span> : text
        //         }
        //     }, {
        //         title: '预计给到客户时间',
        //         dataIndex: 'estimatedDeliveryTime',
        //         key: 'estimatedDeliveryTime',
        //         width: 100,
        //     }, {
        //         title: '报价类型',
        //         dataIndex: 'basicQuotationTypeValue',
        //         key: 'basicQuotationTypeValue',
        //         width: 100,
        //         render: (text, record) => {
        //             const { quotationTypeList } = record;
        //             return <div>
        //                 {
        //                     (quotationTypeList || []).map((el, index, arr) => {
        //                         if (el.crmQuotationTypeLink) {
        //                             return <a onClick={() => window.open(`${el.crmQuotationTypeLink}`)}>
        //                                     {el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}
        //                                 </a>
        //                         } else {
        //                             return <span>{el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}</span>
        //                         }
        //                     })
        //                 }
        //             </div>
        //         }
        //     }, {
        //         title: '需求紧急程度',
        //         dataIndex: 'quotationUrgentLevelValue',
        //         key: 'quotationUrgentLevelValue',
        //         width: 100,
        //     }, {
        //         title: '申办方',
        //         dataIndex: 'sponsorName',
        //         key: 'sponsorName',
        //         width: 100,
        //     }, {
        //         title: '研究产品类型',
        //         dataIndex: 'researchProductTypeName',
        //         key: 'researchProductTypeName',
        //         width: 100,
        //     }, {
        //         title: '临床分期',
        //         dataIndex: 'investigationByStageNames',
        //         key: 'investigationByStageNames',
        //         width: 100,
        //     }, {
        //         title: '试验药物（或器械/试剂）名称',
        //         dataIndex: 'investigationMedicine',
        //         key: 'investigationMedicine',
        //         width: 120,
        //     }, {
        //         title: '适应症',
        //         dataIndex: 'diseaseName',
        //         key: 'diseaseName',
        //         width: 100,
        //     }, {
        //         title: '治疗领域',
        //         dataIndex: 'investigationAreaName',
        //         key: 'investigationAreaName',
        //         width: 100,
        //     }, {
        //         title: '受试者类型',
        //         dataIndex: 'testeeName',
        //         key: 'testeeName',
        //         width: 100,
        //     }, {
        //         title: '业务线',
        //         dataIndex: 'lineOfBusinessString',
        //         key: 'lineOfBusinessString',
        //         width: 100,
        //     }, {
        //         title: '项目分类',
        //         dataIndex: 'invTypeName',
        //         key: 'invTypeName',
        //         width: 100,
        //     }, {
        //         title: '领域leader',
        //         dataIndex: 'talNameCode',
        //         key: 'talNameCode',
        //         width: 120,
        //         render: (text, record) => {
        //             const { talList } = record;
        //             const result = (talList || []).map((el, index, arr) => {
        //                 return <a key={index} onClick={() => this.UserDetailRef.show(el.userId)}>{`${el.userCompellation}[${el.employeeCode}]`}{index < arr.length - 1 ? ';' : ''}<br /></a>;
        //             });
        //             return result
        //         }
        //     }, {
        //         title: 'PM',
        //         dataIndex: 'pmName',
        //         key: 'pmName',
        //         width: 120,
        //         render: (text, record) => {
        //             const { pmName, pmCode, evaluateUserId } = record;
        //             return pmName ? <a onClick={() => this.UserDetailRef.show(evaluateUserId)}>{`${pmName}[${pmCode}]`}</a> : ''
        //         }
        //     }, {
        //         title: 'CRC服务预计开始时间',
        //         dataIndex: 'crcServicePlanStartTime',
        //         key: 'crcServicePlanStartTime',
        //         width: 120,
        //         render: (text) => text ? moment(text).format('YYYY-MM-DD') : '',
        //     }, {
        //         title: '项目年产出（不含税）/人民币',
        //         key: 'invYearQuotationAmount',
        //         children: [
        //             {
        //                 title: '访视报价',
        //                 dataIndex: 'invYearVisitQuotationAmount',
        //                 key: 'invYearVisitQuotationAmount',
        //                 width: 100,
        //                 render: (text, record) => {
        //                     const { nonBindInvYearVisitQuotationAmount, bindInvYearVisitQuotationAmount } = record;
        //                     return (text || text == 0) ?
        //                     <Tooltip overlayStyle={{ width: 160 }} placement="top" title={<div>
        //                         <div>盲态服务：{bindInvYearVisitQuotationAmount}</div>
        //                         <div>非盲服务：{nonBindInvYearVisitQuotationAmount}</div>
        //                     </div>}> 
        //                         <span style={{
        //                             top: '0px',
        //                             left: '0px',
        //                             width: '100%',
        //                             height: '100%',
        //                             position: 'absolute',
        //                             display: 'flex',
        //                             paddingLeft: 10,
        //                             alignItems: 'center',
        //                         }} >
        //                             {`${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        //                         </span>
        //                     </Tooltip> 
        //                     : ''
        //                 } 
        //             },
        //             {
        //                 title: 'FTE报价',
        //                 dataIndex: 'invYearFteQuotationAmount',
        //                 key: 'invYearFteQuotationAmount',
        //                 width: 100,
        //                 render: (text, record) => {
        //                     const { bindInvYearFteQuotationAmount, nonBindInvYearFteQuotationAmount } = record;
        //                     return (text || text == 0) ?
        //                     <Tooltip overlayStyle={{ width: 160 }} placement="top" title={<div>
        //                         <div>盲态服务：{
        //                         (bindInvYearFteQuotationAmount || bindInvYearFteQuotationAmount == 0) ? `${bindInvYearFteQuotationAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
        //                         }</div>
        //                         <div>非盲服务：{
        //                         (nonBindInvYearFteQuotationAmount || nonBindInvYearFteQuotationAmount == 0) ? `${nonBindInvYearFteQuotationAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
        //                         }</div>
        //                     </div>}> 
        //                         <span style={{
        //                             top: '0px',
        //                             left: '0px',
        //                             width: '100%',
        //                             height: '100%',
        //                             position: 'absolute',
        //                             display: 'flex',
        //                             paddingLeft: 10,
        //                             alignItems: 'center',
        //                         }} >
        //                             {`${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        //                         </span>
        //                     </Tooltip> 
        //                     : ''
        //                 } 
        //             },
        //         ]
        //     }, 
        //     {
        //         title: '报价方式',
        //         dataIndex: 'quotationTypeShow',
        //         key: 'quotationTypeShow',
        //         width: 140,
        //     }, {
        //         title: '业务机会状态',
        //         dataIndex: 'businessOpportunityStatusShow',
        //         key: 'businessOpportunityStatusShow',
        //         width: 100,
        //     }, {
        //         title: '申请人BD',
        //         dataIndex: 'bdName',
        //         key: 'bdName',
        //         width: 100,
        //         render: (text, record) => {
        //             const { crmBdName } = record;
        //             return text ? <span>
        //                 {text}
        //                 <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBdName}>
        //                     <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
        //                 </Tooltip>
        //             </span>
        //             : ''
        //         }
        //     }, {
        //         title: '申请人BA',
        //         dataIndex: 'baName',
        //         key: 'baName',
        //         width: 100,
        //         render: (text, record) => {
        //             const { crmBaName } = record;
        //             return text ? <span>
        //                 {text}
        //                 <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBaName}>
        //                     <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
        //                 </Tooltip>
        //             </span>
        //             : ''
        //         }
        //     }, {
        //         title: '评估人',
        //         dataIndex: 'confirmUserName',
        //         key: 'confirmUserName',
        //         width: 100,
        //     }, {
        //         title: '评估人直线主管',
        //         dataIndex: 'confirmUserLeaderName',
        //         key: 'confirmUserLeaderName',
        //         width: 120,
        //     }, 
        // ];
        
        const { tableHeader, canAuditAmountUser, gpOpreateFlag, gpViewFlag, 
            isSeniorUserBo,
            isLineDeptBO,
            isGpFinSet,
            isLineCharge, } = this.state;
        const columns = [{
                title: '序号',
                dataIndex: 'sortNum',
                key: 'sortNum',
                width: 40,
                fixed: 'left',
            }, {
                title: '时间',
                dataIndex: 'yearMonthNum',
                key: 'yearMonthNum',
                width: 60,
                fixed: 'left',
            }, {
                title: '临床评估单号',
                dataIndex: 'evaluateCode',
                key: 'evaluateCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '业务机会编号',
                dataIndex: 'businessOpportunityNum',
                key: 'businessOpportunityNum',
                width: 100,
                fixed: 'left',
            }, {
                title: '方案编号',
                dataIndex: 'evaluateSerialNumber',
                key: 'evaluateSerialNumber',
                width: 100,
                render: (text, record) => <a onClick={() => this.showSchemeInfor(record)}>{text}</a>
            }, {
                title: '报价状态',
                dataIndex: 'evaluateStatusShow',
                key: 'evaluateStatusShow',
                width: 140,
                render: (text, record) => {
                    const { feedbackMessage } = record;
                    return feedbackMessage ? <span> 
                        {text}
                        <Tooltip overlayStyle={{ width: 140 }} placement="top" title={feedbackMessage}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span> : text
                }
            }];
        tableHeader.forEach(el => {
            if (el.isDefault == '0' && el.isShow == '1') {
                const params = {};
                switch (el.dataIndex) {
                    case 'evaluateRecordServes':
                        params.title = el.title;
                        params.dataIndex = 'evaluateRecordServeText';
                        params.key = 'evaluateRecordServeText';
                        params.width = 120;
                        params.render = renderEnhancer(
                            cellRenderEnhancer({
                                renderContent: record => {
                                    const { evaluateRecordServeText } = record;
                                    const evaluateRecordServeList = evaluateRecordServeText?evaluateRecordServeText.split(';'):[]
                                    if ((evaluateRecordServeList || []).length > 1) {
                                        return (
                                            <div>
                                                {
                                                    evaluateRecordServeList.map((el,index) => (
                                                        <div key={index}>
                                                            {el} 
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        );
                                    }
                                }
                            })(text => text ? text.split(';')[0] : '' )
                        );
                        break;
                    case 'basicQuotationTypeValue':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { quotationTypeList } = record;
                            return <div>
                                {
                                    (quotationTypeList || []).map((el, index, arr) => {
                                        if (el.crmQuotationTypeLink) {
                                            return <a onClick={() => window.open(`${el.crmQuotationTypeLink}`)}>
                                                    {el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}
                                                </a>
                                        } else {
                                            return <span>{el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}</span>
                                        }
                                    })
                                }
                            </div>
                        }
                        break;
                    case 'talNameCode':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) =>  {
                            const { talList } = record;
                            const result = (talList || []).map((el, index, arr) => {
                                return <a key={index} onClick={() => this.UserDetailRef.show(el.userId, { needInvInfo: 'N' })}>{`${el.userCompellation}[${el.employeeCode}]`}{index < arr.length - 1 ? ';' : ''}<br /></a>;
                            });
                            return result
                        }
                        break;
                    case 'pm':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { pmName, pmCode, evaluateUserId } = record;
                            return pmName ? <a onClick={() => this.UserDetailRef.show(evaluateUserId, { needInvInfo: 'N' })}>{`${pmName}[${pmCode}]`}</a> : ''
                        }
                        break;
                    case 'crcServicePlanStartTime':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text) => text ? moment(text).format('YYYY-MM-DD') : ''
                        break;
                    case 'bdName':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { crmBdName } = record;
                            return text ? <span>
                                {text}
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBdName}>
                                    <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                                </Tooltip>
                            </span>
                            : ''
                        }
                        break;
                    case 'baName':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { crmBaName } = record;
                            return text ? <span>
                                {text}
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBaName}>
                                    <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                                </Tooltip>
                            </span>
                            : ''
                        }
                        break;
                    case 'evaluateBasicPrice':
                    case 'evaluateBasicPriceTotal':
                    case 'finalBasicPrice':
                    case 'finalBasicPriceTotal':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { 
                                talAuth,    //领域leader
                                deptBoAuth, //部门BO
                                seniorUserAuth,  //王总
                            } = record;
                            return (talAuth || deptBoAuth || seniorUserAuth || canAuditAmountUser) ? text ? format('money', text): '-' : '-'
                        }
                        break;
                    case 'gpCalcuationValue':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { 
                                talAuth,    //领域leader
                                deptBoAuth, //部门BO
                                seniorUserAuth,  //王总
                            } = record;
                            return (talAuth || deptBoAuth || seniorUserAuth || canAuditAmountUser) ? text ? `${text}%` : '-' : '-'
                        }
                        break;
                    case 'onDutyTime':
                    case 'contractSignTime':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text, record) => {
                            const { 
                                talAuth,    //领域leader
                                deptBoAuth, //部门BO
                                seniorUserAuth,  //王总
                            } = record;
                            return (talAuth || deptBoAuth || seniorUserAuth || canAuditAmountUser) ? text : '-'
                        }
                        break;
                    case 'gpValue':
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        params.render = (text) => {
                            return (gpViewFlag && text) ? text + '%' : '-'
                        }
                        break;
                    default:
                        params.title = el.title;
                        params.dataIndex = el.dataIndex;
                        params.key = el.dataIndex;
                        params.width = 120;
                        break;
                }
                columns.push(params);
            }
        })
        columns.push(
            {
                title: <div className="config_clm_oper">
                    <span>操作</span>
                    <Icon 
                        onClick={() => this.configColumn()} 
                        type="setting" 
                        style={{ 
                            float: "right", 
                            fontSize: "18px", 
                            marginRight: "10px" 
                        }}
                    />
                </div>,
                dataIndex: 'operate',
                key: 'operate',
                width: 140,
                fixed: 'right',
                render: (_, record) => {
                    const { curRole } = sessionStorage;
                    const { 
                        seniorUserAuth,  //BO(王总)
                        talAuth,    //领域leader
                        deptBoAuth, //部门BO
                        pmlAuth,  //PML
                        pmAuth,  //PM
                        bdBaAuth,  //BD
                        evaluateStatus, //报价状态
                        quotationType, //报价类型
                        lineChargeAuth,  //业务线负责人
                        specialDesignateUser,  //洪总、王利平、王勖
                        quotationState, //总价申请流程判断
                        secondEvaluationStatus,
                        haveAwardData, //最终报价判断
                        showEvaluateVersion, //是否有评估版本记录
                        showQuotationVersion, //是否有报价版本记录
                        haveTotalPriceData, //是否有总价申请记录
                        basePriceStatus,
                        evaluateRecordId, //评估记录ID
                        productTypeParentId, //项目领域
                        researchProductTypeId, //项目领域
                    } = record;
                    const { 
                        clinicalQuotationState,   //总价申请状态
                        clinicalQuotationType,      //报价类型
                    } = (quotationState || {});

                    //通用权限设置
                    const General = evaluateStatus == 'NEW_EVALUATE' || evaluateStatus == 'CONFIRM' || evaluateStatus == 'REFUSE' || evaluateStatus == 'REPULSE';
                    const isFIN = curRole == 'FIN';
                    const haveTotalPriceRequest = seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth || bdBaAuth || isFIN; //可以查看操作日志中总价申请Tab
                    const isModifyReferencePrice = evaluateStatus == 'SUBMIT' && isLineDeptBO && (quotationType === 'VISIT_FTE_QUOTATION' || quotationType === 'VISIT_QUOTATION');
                    const operationCorrespondRoles = new Map([
                        ['view', {
                            name: '查看',
                            display: true,
                            editable: true,
                            event: () => this.UpdateRef.show(record, 'view'),
                            roles: ['*'],
                        }],
                        ['modifyReferencePrice', {
                            name: '修改参考单价',
                            display: isModifyReferencePrice,
                            editable: true,
                            event: () => this.goModifyReferencePrice(record),
                            roles: ['*'],
                        }],
                        ['floorPrice', {
                            name: '建议底价',
                            display: (deptBoAuth || seniorUserAuth) && evaluateStatus == 'SUBMIT',
                            editable: true,
                            event: () => this.FloorPriceRef.show(record, 'floorPrice'),
                            roles: ['*'],
                        }],
                        ['returned', {
                            name: '退回',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth) && evaluateStatus == 'NEW_EVALUATE',
                            editable: true,
                            event: () => this.ReturnModalRef.show(record, 'returned'),
                            roles: ['*'],
                        }],
                        ['unacceptable', {
                            name: '业务不承接',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth) && evaluateStatus == 'NEW_EVALUATE',
                            editable: true,
                            event: () => this.ReturnModalRef.show(record, 'unacceptable'),
                            roles: ['*'],
                        }],
                        ['configUser', {
                            name: '分配人员',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth || pmlAuth) && General,
                            editable: true,
                            event: () => this.AssignUserRef.show(record, 'User'),
                            roles: ['*'],
                        }],
                        ['edit', {
                            name: '修改',
                            display: ((lineChargeAuth || deptBoAuth || talAuth) && General) || ((pmlAuth || pmAuth) && (evaluateStatus == 'NEW_EVALUATE' || evaluateStatus == 'REFUSE' || evaluateStatus == 'REPULSE')),
                            editable: true,
                            event: () => this.UpdateRef.show(record, 'edit'),
                            roles: ['*'],
                        }],
                        ['visitAssess', {
                            name: '访视评估',
                            display: (lineChargeAuth || deptBoAuth || talAuth || pmlAuth || pmAuth) && General,
                            // display: true,
                            editable: true,
                            event: () => this.showVisitAssess(record),
                            roles: ['*'],
                        }],
                        ['FTEAssess', {
                            name: '一口价（建议评估）',
                            display: (lineChargeAuth || deptBoAuth || talAuth || pmlAuth || pmAuth) && General,
                            editable: true,
                            event: () => this.showFTEAssess(record),
                            roles: ['*'],
                        }],
                        ['affirm', {
                            name: '确认',
                            display: (pmAuth || pmlAuth || talAuth) && (evaluateStatus == 'NEW_EVALUATE' || evaluateStatus == 'REFUSE' || evaluateStatus == 'REPULSE'),
                            editable: true,
                            event: () => this.affirm(record),
                            roles: ['*'],
                        }],
                        ['refer', {
                            name: '提交',
                            display: (talAuth || deptBoAuth || lineChargeAuth) && evaluateStatus == 'CONFIRM',
                            editable: true,
                            event: () => this.refer(record),
                            roles: ['*'],
                        }],
                        ['refuse', {
                            name: '拒绝',
                            display: (talAuth || deptBoAuth || lineChargeAuth) && evaluateStatus == 'CONFIRM',
                            editable: true,
                            event: () => this.OperateReasonRef.show(record, 'refuse'),
                            roles: ['*'],
                        }],
                        ['newRefuse', {
                            name: '拒绝',
                            display: (talAuth || deptBoAuth || lineChargeAuth) && evaluateStatus == 'SUBMIT',
                            editable: true,
                            event: () => this.refuse(record),
                            roles: ['*'],
                        }],
                        ['examine', {
                            name: '总价审批',
                            display: (lineChargeAuth || seniorUserAuth || deptBoAuth) && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL',
                            editable: true,
                            event: () => this.FloorPriceModalRef.show(record, 'examine', basePriceStatus),
                            roles: ['*'],
                        }],
                        ['secEvaluation', {
                            name: '二次评估确认',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth) && (secondEvaluationStatus == 'TO_BE_CONFIRMED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM'),
                            editable: true,
                            event: () => this.SecEvaluationRef.show(record),
                            roles: ['*'],
                        }],
                        ['AssociatedEvaluationRecord', {
                            name: '关联已有评估记录',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || pmAuth || pmlAuth || talAuth) && (evaluateStatus == 'NEW_EVALUATE' || evaluateStatus == 'CONFIRM' || evaluateStatus == 'REFUSE'),
                            editable: true,
                            event: () => this.AssociatedEvaluationRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['TotalPiceRequestRecord', {
                            name: '总价申请记录',
                            //((seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth) && (General ||evaluateStatus == 'SUBMIT')) || ((pmlAuth || pmAuth) && evaluateStatus == 'SUBMIT'),
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth) && haveTotalPriceData,
                            editable: true,
                            event: () => this.TotalPiceRequestRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['versionRecord', {
                            name: '评估版本记录',
                            //((seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth) && (General ||evaluateStatus == 'SUBMIT')) || ((pmlAuth || pmAuth) && evaluateStatus == 'SUBMIT') && showEvaluateVersion
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth || pmlAuth || pmAuth) && showEvaluateVersion,
                            editable: true,
                            event: () => this.VersionRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['visitQuotation', {
                            name: '访视报价',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth) &&  (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM'),

                            editable: true,
                            event: () => this.showVisitQuotation(record),
                            roles: ['*'],
                        }],
                        ['fteQuotation', {
                            name: 'FTE报价',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth) &&  (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM'),
                            editable: true,
                            event: () => this.showFteQuotation(record),
                            roles: ['*'],
                        }],
                        ['finalQuotation', {
                            name: '最终报价',
                            display: (seniorUserAuth || deptBoAuth) && haveAwardData,
                            editable: true,
                            event: () => this.FinalQuotationRef.show(record),
                            roles: ['*'],
                        }],
                        ['quoteVersionRecord', {
                            name: '报价版本记录',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth || talAuth || pmlAuth || pmAuth) &&evaluateStatus == 'SUBMIT' && showQuotationVersion,
                            editable: true,
                            event: () => this.QuoteVersionRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['registerBidding', {
                            name: '登记竞标',
                            display: !bdBaAuth,
                            editable: true,
                            event: () => this.registerBiddingRef.show(record),
                            roles: ['*'],
                        }],
                        ['registerGp', {
                            name: '登记award GP',
                            display: gpOpreateFlag,
                            editable: true,
                            event: () => this.registerGpRef.show(record),
                            roles: ['*'],
                        }],
                        ['evaluateSite', {
                            name: '关联中心',
                            display: this.state.historyStatus !== 'history',
                            editable: true,
                            event: () => this.EvaluateSiteRef.show(record),
                            roles: ['*'],
                        }],
                        ['updateLog', {
                            name: '更新日志',
                            display: true,
                            editable: true,
                            event: () => this.UpdateLogRef.show(record),
                            roles: ['*'],
                        }],
                        ['operationLog', {
                            name: '操作日志',
                            display: true,
                            editable: true,
                            event: () => this.OperationLogRef.show(record, '0', haveTotalPriceRequest, talAuth, isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge,),
                            roles: ['*'],
                        }],
                    ]);
                    return (
                        <span className="operateBarLineWrap">
                            {   fp.compose(
                                    fp.curry(cf.operationAuthByRole)( 
                                        index => <span key={index} className="ant-divider" />
                                    ),
                                    fp.filter(i => !!i),
                                    // 获取角色对应操作
                                    fp.curry(cf.authDomList)(operationCorrespondRoles)
                                )(curRole)
                            }
                        </span>
                    );
                }
            }
        )
        return columns;
    };

    getGPColumns = () => {
        const {
            isSeniorUserBo,
            isLineDeptBO,
            isLineCharge,
            isGpFinSet,
        } = this.state;
        const showFlag = isSeniorUserBo || isLineDeptBO || isLineCharge;
        const positionRole = sessionStorage.positionRole;
        const gpOpreateFlag = ['BDO', 'BAL', 'BD', 'BA'].includes(positionRole)
        const columns = [{
                title: '序号',
                dataIndex: 'sortNum',
                key: 'sortNum',
                width: 40,
                fixed: 'left',
            }, {
                title: '时间',
                dataIndex: 'yearMonthNum',
                key: 'yearMonthNum',
                width: 80,
                fixed: 'left',
            }, {
                title: '临床评估单号',
                dataIndex: 'evaluateCode',
                key: 'evaluateCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '业务机会编号',
                dataIndex: 'businessOpportunityNum',
                key: 'businessOpportunityNum',
                width: 100,
                fixed: 'left',
            }, {
                title: '方案编号',
                dataIndex: 'evaluateSerialNumber',
                key: 'evaluateSerialNumber',
                width: 100,
                render: (text, record) => <a onClick={() => this.showSchemeInfor(record)}>{text}</a>
            }, {
                title: '报价状态',
                dataIndex: 'evaluateStatusShow',
                key: 'evaluateStatusShow',
                width: 140,
                // render: (text, record) => {
                //     const { feedbackMessage } = record;
                //     return feedbackMessage ? <span> 
                //         {text}
                //         <Tooltip overlayStyle={{ width: 140 }} placement="top" title={feedbackMessage}>
                //             <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                //         </Tooltip>
                //     </span> : text
                // }
            }, {
                title: '合同签署方',
                dataIndex: 'contractSignName',
                key: 'contractSignName',
                width: 120,
            }, {
                title: '申办方',
                dataIndex: 'sponsorName',
                key: 'sponsorName',
                width: 100,
            }, {
                title: '研究产品类型',
                dataIndex: 'researchProductTypeName',
                key: 'researchProductTypeName',
                width: 120,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 100,
            }, 
            {
                title: '项目分类',
                dataIndex: 'invTypeName',
                key: 'invTypeName',
                width: 100,
            }, 
            {
                title: '治疗领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 100,
            }, 
            {
                title: '疾病（适应症）',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 120,
            }, 
            {
                title: '临床分期',
                dataIndex: 'investigationByStageNames',
                key: 'investigationByStageNames',
                width: 100,
            }, 
            {
                title: '领域leader',
                dataIndex: 'talNameCode',
                key: 'talNameCode',
                width: 120,
                render: (text, record) =>  {
                    const { talList } = record;
                    const result = (talList || []).map((el, index, arr) => {
                        return <a key={index} onClick={() => this.UserDetailRef.show(el.userId, { needInvInfo: 'N' })}>{`${el.userCompellation}[${el.employeeCode}]`}{index < arr.length - 1 ? ';' : ''}<br /></a>;
                    });
                    return result
                }
            },
            {
                title: 'PM',
                dataIndex: 'pmName',
                key: 'pm',
                width: 120,
                render: (text, record) => {
                    const { pmName, pmCode, evaluateUserId } = record;
                    return pmName ? <a onClick={() => this.UserDetailRef.show(evaluateUserId, { needInvInfo: 'N' })}>{`${pmName}[${pmCode}]`}</a> : ''
                }
            }, 
            {
                title: '业务机会状态',
                dataIndex: 'businessOpportunityStatusShowCn',
                key: 'businessOpportunityStatusShowCn',
                width: 120,
            },
            {
                title: '申请人BD',
                dataIndex: 'bdName',
                key: 'bd',
                width: 120,
                // render: (text, record) => {
                //     const { crmBdName } = record;
                //     return text ? <span>
                //         {text}
                //         <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBdName}>
                //             <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                //         </Tooltip>
                //     </span>
                //     : ''
                // }
            }, 
            {
                title: '申请人BA',
                dataIndex: 'baName',
                key: 'ba',
                width: 120,
                // render: (text, record) => {
                //     const { crmBaName } = record;
                //     return text ? <span>
                //         {text}
                //         <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBaName}>
                //             <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                //         </Tooltip>
                //     </span>
                //     : ''
                // }
            }, 
            {
                title: '启动中心数',
                dataIndex: 'startSiteNum',
                key: 'startSiteNum',
                width: 120,
            }, 
            {
                title: '研究周期 (估计时间)（月）',
                dataIndex: 'researchCycle',
                key: 'researchCycle',
                width: 120,
            }, 
            // {
            //     title: '建议底价方式',
            //     dataIndex: 'basePriceStatus',
            //     key: 'basePriceStatus',
            //     width: 120,
            //     render: (text, record) => {
            //         const { basePriceStatus } = record;
            //         return basePriceStatus === 'VISIT' ? '访视制' : basePriceStatus === 'FTE' ? 'FTE制' : '';
            //     }
            // }, 
            {
                title: '报价模型',
                dataIndex: 'quotationCalculateType',
                key: 'quotationCalculateType',
                width: 120,
                render: (text, record) => {
                    const { quotationCalculateType } = record;
                    return quotationCalculateType === 'VISIT' ? '访视制' : quotationCalculateType === 'FTE' ? 'FTE制' : '';
                }
            }, 
            {
                title: '项目难度系数',
                dataIndex: 'invDifficultyCoefficient',
                key: 'invDifficultyCoefficient',
                width: 120,
            }, 
            {
                title: '评估例数（随机病例数）',
                dataIndex: 'randomCaseNum',
                key: 'randomCaseNum',
                width: 120,
            }, 
            {
                title: '标准访视数量',
                dataIndex: 'planStandardVisitAmount',
                key: 'planStandardVisitAmount',
                width: 120,
            }, 
            {
                title: '评估FTE数',
                dataIndex: 'evaluateFteValue',
                key: 'evaluateFteValue',
                width: 120,
            }, 
            {
                title: '单位FTE标准访视数（标访/FTE）',
                dataIndex: 'visitRatioFte',
                key: 'visitRatioFte',
                width: 120,
            }, 
            {
                title: '评估标准访视数（Adj）',
                dataIndex: 'standardVisitAdj',
                key: 'standardVisitAdj',
                width: 120,
            }, 
            {
                title: '是否特批价格',
                dataIndex: 'specialApprovalShow',
                key: 'specialApprovalShow',
                width: 120,
            }, 
            {
                title: '参考标准访视单价',
                dataIndex: 'calAreaDiseaseShow',
                key: 'calAreaDiseaseShow',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '评估底价标准访视单价',
                dataIndex: 'evaluateMinStandVisitUnitPrice',
                key: 'evaluateMinStandVisitUnitPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '评估底价单例价格',
                dataIndex: 'evaluateMinUnitPrice',
                key: 'evaluateMinUnitPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '评估底价合同总价',
                dataIndex: 'evaluateMinJdeTotalPrice',
                key: 'evaluateMinJdeTotalPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '评估底价GP金额',
                dataIndex: 'evaluateMinGpAmount',
                key: 'evaluateMinGpAmount',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '评估底价GP%',
                dataIndex: 'evaluateMinGpPercent',
                key: 'evaluateMinGpPercent',
                width: 120,
                render: text => text !== null ? `${text}%` : ''
            }, 
            {
                title: '评估底价FTE单价',
                dataIndex: 'evaluateMinFteUnitPrice',
                key: 'evaluateMinFteUnitPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: 'award 日期',
                dataIndex: 'awardDate',
                key: 'awardDate',
                width: 120,
            }, 
            {
                title: 'Award 金额（不含税）',
                dataIndex: 'awardAmountCnyNoTax',
                key: 'awardAmountCnyNoTax',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: 'Award 例数',
                dataIndex: 'awardCaseNum',
                key: 'awardCaseNum',
                width: 120,
            }, 
            {
                title: 'Award 标准访视数（Adj）',
                dataIndex: 'awardStandardVisitAdj',
                key: 'awardStandardVisitAdj',
                width: 120,
            }, 
            {
                title: 'Award 标准访视单价',
                dataIndex: 'awardStandardUnitPrice',
                key: 'awardStandardUnitPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: 'Award GP金额',
                dataIndex: 'awardGpAmount',
                key: 'awardGpAmount',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: 'Award GP%',
                dataIndex: 'awardGpPercent',
                key: 'awardGpPercent',
                width: 120,
                render: text => text !== null ? `${text}%` : ''
            }, 
            {
                title: '合同实际签署日期',
                dataIndex: 'jdeActualSignDate',
                key: 'jdeActualSignDate',
                width: 120,
            }, 
            {
                title: '已签署合同金额(不含税)',
                dataIndex: 'jdeContractAmountCnyNoTax',
                key: 'jdeContractAmountCnyNoTax',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '已签署合同例数',
                dataIndex: 'jdeContractCaseNum',
                key: 'jdeContractCaseNum',
                width: 120,
            }, 
            {
                title: '已签署合同标准访视数（Adj）',
                dataIndex: 'jdeStandardVisitAdj',
                key: 'jdeStandardVisitAdj',
                width: 120,
            }, 
            {
                title: '已签署合同标准访视单价',
                dataIndex: 'jdeStandardVisitUnitPrice',
                key: 'jdeStandardVisitUnitPrice',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '已签署合同GP金额',
                dataIndex: 'jdeGpAmount',
                key: 'jdeGpAmount',
                width: 120,
                render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
            }, 
            {
                title: '已签署合同GP%',
                dataIndex: 'jdeGpPercent',
                key: 'jdeGpPercent',
                width: 120,
                render: text => text !== null ? `${text}%` : ''
            }, 
            {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                fixed: 'right',
                render: (_, record) => {
                    const { 
                        evaluateStatus, //报价状态
                        basePriceStatus, //评估底价状态
                        evaluateRecordId, //评估记录ID
                    } = record;
                    //通用权限设置
                    const General = evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM';
                    const isModifyReferencePrice = evaluateStatus == 'SUBMIT' && isLineDeptBO;
                    return (
                        <span className="operateBarLineWrap">
                            {
                                General && isGpFinSet && <a onClick={() => this.goGpCalculate(evaluateRecordId, basePriceStatus)}>GP% 测算</a>
                            }
                        </span>
                    );
                }
            }];

        if (gpOpreateFlag) {
            // 隐藏 项目难度系数、标准访视数量、单位FTE标准访视数（标访/FTE）、评估底价FTE单价、参考标准访视单价
            const hiddenKeys = ['invDifficultyCoefficient', 'planStandardVisitAmount', 'visitRatioFte', 'evaluateMinFteUnitPrice', 'calAreaDiseaseShow'];
            return columns.filter(column => !hiddenKeys.includes(column.key));
        }
        if (showFlag) {
            const hiddenKeys = ['evaluateMinFteUnitPrice'];
            return columns.filter(column => !hiddenKeys.includes(column.key));
        }

        return columns;
    };

    configColumn = () => {
        const { tableHeader } = this.state;
        this.configColumnRef.show(tableHeader);
    }

    showCustomerQuotation = record => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotation,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.TotalPriceModalRef.show(record, 'quotation', data)
            }
        };
        $.sendRequest(options);
    }

    affirm = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.confirmEvaluateRecord,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    refer = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.auditEvaluateRecord,
            data: {
                evaluateRecordId,
                approvalStatus: 'AGREE',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    showVisitAssess = (record) => {
        const { evaluateRecordId } = record;
        const { searchParams, pagination } = this.state;
        this.props.saveEvaluateParams({
            evaluateSearchParams: searchParams,
            evaluatePagination: pagination,
        });
        location.href = `./#/clinicalEvaluation/visitAssess/${evaluateRecordId}`;
    }

    showFTEAssess = (record) => {
        const { evaluateRecordId } = record;
        const { searchParams, pagination } = this.state;
        this.props.saveEvaluateParams({
            evaluateSearchParams: searchParams,
            evaluatePagination: pagination,
        });
        location.href = `./#/clinicalEvaluation/FTEAssess/${evaluateRecordId}`;
    }

    //初始化报价单
    doStartClinicalQuotation = (clinicalQuotationId, evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.doStartClinicalQuotation,
            data: {
                clinicalQuotationId,
            },
            dataType: 'json',
            doneResult: (res) => {
                location.href = `./#/clinicalEvaluation/visitQuotation/${evaluateRecordId}`;
            }
        };
        $.sendRequest(options);
    }

    applyTotalPice = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotationRequest,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.TotalPriceModalRef.show(record, 'apply', data)
            },
        };
        $.sendRequest(options);
    }

    confirmTotalPice = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotationApproval,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.TotalPriceModalRef.show(record, 'confirm', data)
            },
        };
        $.sendRequest(options);
    }

    showVisitQuotation = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotation,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { clinicalQuotationId } = res.data;
                const { searchParams, pagination } = this.state;
                this.props.saveEvaluateParams({
                    evaluateSearchParams: searchParams,
                    evaluatePagination: pagination,
                    isClinicalEvaluation: true,
                });
                this.doStartClinicalQuotation(clinicalQuotationId, evaluateRecordId);
            }
        };
        $.sendRequest(options);
    }

    showFteQuotation = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotation,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { clinicalQuotationId } = res.data;
                const { searchParams, pagination } = this.state;
                this.props.saveEvaluateParams({
                    evaluateSearchParams: searchParams,
                    evaluatePagination: pagination,
                    isClinicalEvaluation: true,
                });
                this.doStartClinicalFteQuotation(clinicalQuotationId, evaluateRecordId);
            }
        };
        $.sendRequest(options);
    }

    //初始化FTE报价单
    doStartClinicalFteQuotation = (clinicalQuotationId, evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.doStartClinicalFteQuotation,
            data: {
                clinicalQuotationId,
            },
            dataType: 'json',
            doneResult: () => {
                location.href = `./#/clinicalEvaluation/fteQuotation/${evaluateRecordId}`;
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = (params) => {
        const { historyStatus } = this.state;
        this.setState({
            ...params,
        }, () => {
            if (historyStatus === 'GP') {
                this.loadGPData();
            } else {
                this.loadData();
            }
        });
    }

    export = () => {
        const { searchParams, historyStatus } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const curParams = this.splitParams(searchParams);
        let url = API_URL.evaluate.exportEvaluateRecords;
        if (historyStatus === 'GP') {
            url = API_URL.evaluate.exportQuotationGpDataList;
        }
        ExportUtil.export({ 
            ...curParams,
            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
        }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTabClick = (key) => {
        this.setState({
            historyStatus: key,
        },() => {
            if (key === 'GP') {
                this.loadGPData();
            } else {
                this.loadData();
            }
        })
    }

    refuse = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.boRefuseEvaluateRecord,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const dataSource = [];
        data.map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * 10 + index + 1,
            });
        });
        return dataSource
    }

    render() {
        const {
            data,
            loading,
            pagination,
            searchParams,
            historyStatus,
            isSeniorUserBo,
            isLineDeptBO,
            isGpFinSet,
            isLineCharge,
        } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='record'/>
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        dataExport={this.export}
                        historyStatus={historyStatus}
                        isSeniorUserBo={isSeniorUserBo}
                        isLineDeptBO={isLineDeptBO}
                        isGpFinSet={isGpFinSet}
                        isLineCharge={isLineCharge}
                    />
                    <Tabs type="card" activeKey={historyStatus} onChange={this.handleTabClick}>
                        {(() => {
                            const { isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge } = this.state;
                            const { positionRole } = sessionStorage;
                            // 判断是否显示GP tab
                            const showGpTab = 
                                isSeniorUserBo || 
                                isLineDeptBO || 
                                isGpFinSet || 
                                isLineCharge || 
                                ['BDO', 'BAL', 'BD', 'BA'].includes(positionRole);
                            
                            // 根据条件生成tabs
                            const displayTabs = showGpTab ? tabs : tabs.filter(tab => tab.key !== 'GP');
                            return displayTabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>);
                        })()}
                    </Tabs>
                    {
                        historyStatus !== 'GP' && (
                            <TableC
                                data={this.getDataSource()}
                                scrollY={480}
                                loading={loading}
                                columns={this.getColumns()}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                            />
                        )
                    }
                    {
                        historyStatus === 'GP' && (
                            <TableC
                                data={this.getDataSource()}
                                scrollY={480}
                                loading={loading}
                                columns={this.getGPColumns()}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                            />
                        )
                    }
                    
                    <SchemeInfor
                        ref={el => this.SchemeInforRef = el}
                    />
                    <AssignUser 
                        loadData={this.loadData}
                        ref={el => this.AssignUserRef = el}
                    />
                    <VersionRecord
                        ref={el => this.VersionRecordRef = el}
                    />
                    <UpdateLog
                        ref={el => this.UpdateLogRef = el}
                    />
                    <OperationLog
                        ref={el => this.OperationLogRef = el}
                    />
                    <Update 
                        loadData={this.loadData}
                        ref={el => this.UpdateRef = el}
                    />
                    <OperateReason 
                        loadData={this.loadData}
                        ref={el => this.OperateReasonRef = el}
                    />
                    <TotalPriceModal
                        loadData={this.loadData}
                        ref={el => this.TotalPriceModalRef = el}
                    />
                    <SecEvaluation
                        loadData={this.loadData}
                        ref={el => this.SecEvaluationRef = el}
                    />
                    <QuoteVersionRecord
                        loadData={this.loadData}
                        ref={el => this.QuoteVersionRecordRef = el}
                    />
                    <FinalQuotation
                        loadData={this.loadData}
                        ref={el => this.FinalQuotationRef = el}
                    />
                    <ReturnModal
                        loadData={this.loadData}
                        ref={el => this.ReturnModalRef = el}
                    />
                    <FloorPrice
                        loadData={this.loadData}
                        ref={el => this.FloorPriceRef = el}
                    />
                    <TotalPiceRequestRecord
                        ref={el => this.TotalPiceRequestRecordRef = el}
                    />
                    <UserDetail
                        ref={el => this.UserDetailRef = el}
                    />
                    <FloorPriceModal
                        loadData={this.loadData}
                        ref={el => this.FloorPriceModalRef = el}
                    />
                    <AssociatedEvaluationRecord
                        loadData={this.loadData}
                        ref={el => this.AssociatedEvaluationRecordRef = el}
                    />
                    <ConfigColumn
                        getHeader={this.getHeader}
                        ref={el => this.configColumnRef = el}
                    />
                    <RegisterBidding
                        loadData={this.loadData}
                        ref={el => this.registerBiddingRef = el}   
                    />
                    <RegisterGp
                        loadData={this.loadData}
                        ref={el => this.registerGpRef = el}   
                    />
                    <GPCalculateModal
                        ref={ref => this.GPCalculateModalRef = ref}
                    />
                    <ModifyReferencePriceModal
                        loadData={this.loadData}
                        ref={ref => this.ModifyReferencePriceModalRef = ref}
                    />
                    <EvaluateSite
                        ref={el => this.EvaluateSiteRef = el}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        evaluateParams: state.clinicalEvaluationState.evaluateParams,
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveEvaluateParams: (params) => dispatch(saveEvaluateParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClinicalEvaluationRecord);



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/index.js